import { useQuery } from "@tanstack/react-query";
import { VisitorStation } from "@gettactic/api";

export interface VisitorStationAPI {
  client: {
    visitorStations: {
      get: (id: string) => Promise<{
        ok: boolean;
        result?: VisitorStation | null;
      }>;
    };
  };
}

export const VISITOR_STATION_QUERY_KEY = "visitorStation";

export interface UseVisitorStationOptions {
  stationId: string | null;
  enabled?: boolean;
}

export function useVisitorStation(
  options: UseVisitorStationOptions,
  api: VisitorStationAPI
) {
  const { stationId, enabled = true } = options;

  return useQuery({
    queryKey: [VISITOR_STATION_QUERY_KEY, stationId],
    queryFn: async () => {
      if (!stationId) return null;
      const response = await api.client.visitorStations.get(stationId);
      if (response.ok && response.result) {
        return response.result;
      }
      return null;
    },
    enabled: enabled && !!stationId
  });
}
